<template>
  <div class="redemptions-chart">
    <div>
      <div>
        <h1>Resgates</h1>
        <table class = "table center">
        <thead>
          <tr>
          <th></th>
          <th>Quantidade</th>
          <th>Valor</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>Britz</td>
          <td>{{ redemptions_info.britz_qnt || 0 }}</td>
          <td>{{ redemptions_info.britz_value || 'R$ 0.00' }}</td>
        </tr>
        <tr>
          <td>Mapipay</td>
          <td><div class="tooltip1">{{ redemptions_info.mapipay_qnt_total || 0 }} <span class="tooltiptext">Dormentes: {{redemptions_info.mapipay_qnt_sleepy || 0}}<br>Pendentes: {{redemptions_info.mapipay_qnt_pending || 0}}<br>Resgatados: {{redemptions_info.mapipay_qnt_finished || 0}}</span></div></td>
          <td><div class="tooltip1">{{ redemptions_info.mapipay_value_total || 0 | currency}} <span class="tooltiptext">Dormentes: {{redemptions_info.mapipay_value_sleepy || 0 | currency}}<br>Pendentes: {{redemptions_info.mapipay_value_pending || 0 | currency}}<br>Resgatados: {{redemptions_info.mapipay_value_finished || 0 | currency}}</span></div></td>
        </tr>
        <tr>
          <td>Vale-Presente</td>
          <td><div class="tooltip1">{{ redemptions_info.card_qnt_total || 0 }} <span class="tooltiptext">Dormentes: {{redemptions_info.card_qnt_sleepy || 0}}<br>Pendentes: {{redemptions_info.card_qnt_pending || 0}}<br>Resgatados: {{redemptions_info.card_qnt_finished || 0}}<br>Taxas 1 Real: {{redemptions_info.card_tax || 0}}</span></div></td>
          <td><div class="tooltip1">{{ redemptions_info.card_value_total || 0 | currency}} <span class="tooltiptext">Dormentes: {{redemptions_info.card_value_sleepy || 0 | currency}}<br>Pendentes: {{redemptions_info.card_value_pending || 0 | currency}}<br>Resgatados: {{redemptions_info.card_value_finished || 0 | currency}}<br>Taxas 1 Real: {{redemptions_info.card_tax || 0 | currency}}</span></div></td>
        </tr>
        <tr>
          <td>Estornos</td>
          <td>{{ redemptions_info.chargebacks_qnt || 0 }}</td>
          <td>{{ redemptions_info.chargebacks || 0 | currency}}</td>
        </tr>
        </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'redemptions-card',
  computed: mapState({
    redemptions_info: (state) => state.dashboard.redemptions_info,
  }),
  data: () => {
    return {
      isExporting: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.redemptions-chart {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 10px 0px;
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);

  h1{
    margin-left: 25px;
    align-content: center;
    font-size: 1.2rem;
    padding-top: 10px;
  }
  table{
    width: 100%;
    td{
    text-align: center;
    }

    th{
    text-align: center;
    }
  }
}

.tooltip1 {
  position: relative;
  display: inline-block;
}

.tooltip1 .tooltiptext {
  visibility: hidden;
  width: 200px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
}

.tooltip1:hover .tooltiptext {
  visibility: visible;
}
</style>
